import { RouteObject } from "react-router";

import { convertRouteModule } from "../../../lib/routing";

export const areaRoutes: Array<RouteObject> = [
  { index: true, lazy: async () => convertRouteModule(await import("./areas")) },
  {
    path: ":areaId",
    lazy: async () => convertRouteModule(await import("./area-detail")),
  },
];
